import { Button, CircularProgress, Stack } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import DashboardBox from '../components/DashboardBox';
import { useUserInfo } from '../providers/UserProvider';
import StudentAutocomplete from '../components/formik/StudentAutocomplete';
import { Form, Formik } from 'formik';
import TextField from '../components/formik/TextField';
import OutlinedButton from '../components/button/OutlinedButton';
import TeacherUtil from '../utils/TeacherUtil';

const Profile = () => {
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const { dispatch } = useUserInfo();
  const initialValues = useMemo(
    () => ({
      firstName: currentEmployee?.firstName || '',
      lastName: currentEmployee?.lastName || '',
      students: (currentEmployee?.students?.split(',') || []).map(id => parseInt(id)),
    }),
    [currentEmployee],
  );

  const onSubmit = (values, { setSubmitting }) => {
    TeacherUtil.updateTeacher(currentEmployee.id, values)
      .then(() => {})
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    TeacherUtil.getCurrentTeacher().then(response => {
      setCurrentEmployee(response.data);
    });
  }, []);

  return (
    <div style={{ display: 'inline-flex', width: '100%', maxWidth: 400 }}>
      <DashboardBox>
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <p className="title">Profiel</p>
            {currentEmployee === null && <CircularProgress size={16} />}
          </Stack>
          {currentEmployee !== null && (
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
              {({ isValid, isSubmitting }) => (
                <Form>
                  <Stack spacing={2}>
                    <TextField name="firstName" label="Voornaam*" />
                    <TextField name="lastName" label="Achternaam*" />
                    <StudentAutocomplete name="students" initialValues={initialValues.students} />

                    <Button variant="contained" type="submit" disabled={!isValid || isSubmitting}>
                      Opslaan
                      {isSubmitting && <CircularProgress size={14} sx={{ ml: 1 }} />}
                    </Button>
                    <OutlinedButton
                      onClick={() => {
                        dispatch({ type: 'NOT_AUTHENTICATED' });
                      }}
                    >
                      Log uit
                    </OutlinedButton>
                  </Stack>
                </Form>
              )}
            </Formik>
          )}
        </Stack>
      </DashboardBox>
    </div>
  );
};

export default Profile;
